import React from 'react';
import { BrandLogo } from './BrandLogo';
import { ChainSelector } from './ChainSelector';
import { PegStatus } from './PegStatus';
import { WalletHeaderControls } from './WalletHeaderControls';

export const Header = ({
  chains = [],
  comingSoonChains = [],
  selectedChainKey,
  selectedChain,
  isChainMenuOpen,
  onToggleChainMenu,
  onCloseChainMenu,
  onSelectChain,
  isConnected,
  isWalletNetworkAligned,
  networkDisplayName,
  address,
  connectButtonText,
  onConnect,
  onDisconnect,
  onCopyAddress,
  copyFeedback,
  isDebugMode,
  toggleTargetNetworkName,
  onSwitchNetwork,
}) => {
  return (
    <header className="header" role="banner">
      <div className="header-container">
        <BrandLogo />
        <ChainSelector
          chains={chains}
          comingSoonChains={comingSoonChains}
          selectedChainKey={selectedChainKey}
          selectedChain={selectedChain}
          isOpen={isChainMenuOpen}
          onToggle={onToggleChainMenu}
          onClose={onCloseChainMenu}
          onSelectChain={onSelectChain}
          isConnected={isConnected}
          isWalletNetworkAligned={isWalletNetworkAligned}
          networkDisplayName={networkDisplayName}
        />
        <div className="wallet-info">
          <PegStatus />
          <WalletHeaderControls
            isConnected={isConnected}
            address={address}
            connectButtonText={connectButtonText}
            onConnect={onConnect}
            onDisconnect={onDisconnect}
            onCopyAddress={onCopyAddress}
            copyFeedback={copyFeedback}
            isDebugMode={isDebugMode}
            selectedChainKey={selectedChainKey}
            toggleTargetNetworkName={toggleTargetNetworkName}
            onSwitchNetwork={onSwitchNetwork}
          />
        </div>
      </div>
    </header>
  );
};
